import type { FilterUsersQuery } from '../../generated/gql/graphql'
import type { EditorUser } from '../types'

export const formatUsersWithoutCreator = (
    users: NonNullable<NonNullable<FilterUsersQuery['users']>['nodes']>,
    creatorId?: string,
): EditorUser[] => {
    const formattedUsers: EditorUser[] = users
        .filter((user) => user.id !== creatorId)
        .map((user) => {
            return {
                id: user.id,
                name: user.displayName,
                email: user.email,
                imageUrl: user.imageUrl ?? null,
                meetplaceId: user.meetplaceId,
                role: user.role,
            }
        })
    return formattedUsers
}
